import axios from 'axios';

export const api = axios.create({
    baseURL: "https://sigma.gdar.mx/"
});

api.interceptors.request.use(async (config: any) => {
    const con = new apiConfig();
    const token = await con.getToken();
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }

    return config;
})

export class apiConfig {
    getToken = async () => {
        try {
          const datos: string = JSON.stringify({
                username: "serviciosFarmaceuticos",
                password: 'xrbpj<5c9G5*U#%L'
           });

          const {data} = await axios.post('https://sigma.gdar.mx/login', datos, {
            headers: {'Content-Type': 'application/json'},
          });

          return data;
        } catch (error) {
          throw new Error(`Error fetching token ${error}`);
        }
      };
}
